import React from "react";
import { Modal, Form, Row, Col, notification } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ControlledInput from "../../components/Backoffice/ControlledInput";

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Test Category Name"),
});

const openNotification = () => {
  notification.success({
    message: "Success!",
    description: "Added new test category",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const TestCategoryForm = ({ visible, setVisible, onSave }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
    resolver: yupResolver(schema),
  });

  const handleSuccess = () => {
    reset();
    setVisible(false);
    openNotification();
  };

  const handleFailure = () => {
    console.log("An error occured");
  };

  const onSubmit = (data) => {
    const payloadData = {
      name: data.name.trim().split(/ +/).join(" "),
    };
    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };

    onSave(payload);
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
  };

  return (
    <Modal
      title="Add Test Category"
      visible={visible}
      okText="Save"
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
    >
      <Form colon={false}>
        <Row gutter={24}>
          <Col span={24}>
            <ControlledInput
              required
              control={control}
              name="name"
              label="Test Category Name"
              errors={errors}
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TestCategoryForm;
